module.exports = __webpack_public_path__ + "static/img/zhinengkongzhi_details.60728da5.jpg";